import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner } from '@ds';
import { ReactNode } from 'react';

export type OverrideFlowModalProps = {
  title: string;
  description: ReactNode;
  actionButtonTitle: string;
  isOpen: boolean;
  isLoading: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onAction: () => void;
  onClose: () => void;
};

export const OverrideFlowModal = ({
  title,
  description,
  actionButtonTitle,
  isOpen,
  isLoading,
  size = 'lg',
  onAction,
  onClose,
}: OverrideFlowModalProps) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      hideCloseButton
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            {isLoading && (
              <div className="absolute top-0 left-0 flex justify-center items-center z-50 w-full h-full bg-white bg-opacity-40">
                <Spinner size="md" />
              </div>
            )}
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>{description}</ModalBody>
            <ModalFooter>
              <Button isDisabled={isLoading} size="md" variant="outline" onClick={onAction}>
                {actionButtonTitle}
              </Button>
              <Button size="md" color="default" variant="solid" onClick={handleClose}>
                Discard
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
